<template>


<div style="margin: 5px;">
    <InputGroup>
    <InputGroupAddon>Company Address(中文)</InputGroupAddon>
    <InputText placeholder="Company Address(中文)" v-model="value" :required="required" :disabled="disabled"  :class="{'p-invalid': isError}" />
</InputGroup>
</div>

 
</template>  
<script>

export default {
    props: ["modelValue", 'disabled','required'],
    emits:["update:modelValue","update:error"],
    data() {
        return {
            value: "中文公司地址"
        }
    },
    created(){
        this.value = this.modelValue
    },
    mounted(){
        this.value = (this.modelValue);
        this.$emit("update:error", this.isError);
      },
      computed:{
        isError(){
            return  !this.value && this.required;
        }
    },
    watch: {
            value: function (newVal) {
              // watch it
              //console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.$emit("update:modelValue", newVal );
              this.$emit("update:error", this.isError);
            },
          },
}
</script>
  
  